import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";

export const useGetRedefinirSenha = (token: string) => {
  return useFetch<string>({
    key: ["redefinir-senha", token],
    url: `${api.usuario.getRedefinirSenha}/${token}`,
    enabled: !!token,
  });
};
